import dayjs from "dayjs";

/**
 * 获取n年后的时间
 * @param {string|number|Date} now
 * @param {number} years
 * @returns {Date}
 */
export function addYears(now, years = 1) {
  return dayjs(now).add(years, "y");
}

/**
 * 获取n天后的时间
 * @param {string|number|Date} now
 * @param {number} days
 * @returns {Date}
 */
export function addDays(now, days) {
  return new Date(new Date(now).getTime() + 24 * 3600 * 1000 * days);
}

/**
 * 获取 a-b 相差多少天
 * @param {number|Date|string} a 日期a
 * @param {number|Date|string} b 日期b
 * @returns {number}
 */
export function getDiffDays(a, b) {
  return dayjs(a).diff(dayjs(b), "days", true);
}
